const saveInterventions = data => {
    return {
        type: 'SAVE_INTERVENTIONS',
        data
    };
};
const saveInterventionsData = data => {
    return {
        type: 'SAVE_INTERVENTIONS_DATA',
        data
    };
};
const saveConversationList = data => {
    return {
        type: 'SAVE_CONVERSATION_LIST',
        data
    };
};
const saveConversation = (id, data) => {
    return {
        type: 'SAVE_CONVERSATION',
        data,
        id
    };
};
const removeConversation = id => {
    return {
        type: 'REMOVE_CONVERSATION',
        id
    };
};
const onInterventionClick = (data, userId, itemId) => {
    return {
        type: 'INTERVENTION_CLICK',
        data,
        userId,
        itemId
    };
};
const updateImagesData = data => {
    return {
        type: 'UPDATE_IMAGES_DATA',
        data
    };
};
const setChatStatus = data => {
    return {
        type: 'SET_CHAT_STATUS',
        data
    };
};
const saveMessage = data => {
    return {
        type: 'SAVE_MESSAGE',
        data
    };
};
const saveMessages = data => {
    return {
        type: 'SAVE_MESSAGES',
        data
    };
};
const saveThreads = data => {
    return {
        type: 'SAVE_THREADS',
        data
    };
};
const updateThread = data => {
    return {
        type: 'UPDATE_THREAD',
        data
    };
};
const setBatchIndex = data => {
    return {
        type: 'SET_BATCH_INDEX',
        data
    };
};
const setOffsetIndex = data => {
    return {
        type: 'SET_OFFSET_INDEX',
        data
    };
};
const setUnreadCount = data => {
    return {
        type: 'SET_TOTAL_UNREAD_COUNT',
        data
    };
};
const saveSafetyTips = data => {
    return {
        type: 'SAVE_SAFETY_TIPS',
        data
    };
};

const saveReplyRestrictionMetaData = data => {
    return {
        type: 'SAVE_REPLY_RESTRICTION_METADATA',
        data
    };
};

const saveKYCReplyRestrictionData = data => {
    return {
        type: 'SAVE_KYC_REPLY_RESTRICTION_METADATA',
        data
    };
};

const saveSystemMessageData = data => {
    return {
        type: 'SAVE_SYSTEM_MESSAGE_DATA',
        data
    };
};

const saveMyZoneFeatureFlag = data => {
    return {
        type: 'SAVE_MY_ZONE_FEATURE_FLAG',
        data
    };
};

const saveIntentCtas = data => {
    return {
        type: 'SAVE_INTENT_CTAS',
        data
    };
};

const setChatQuickFilters = data => {
    return {
        type: 'CHAT_SET_QUICK_FILTERS',
        data
    };
};

export {
    saveMessage,
    saveThreads,
    updateThread,
    saveMessages,
    saveInterventions,
    saveInterventionsData,
    saveConversationList,
    saveConversation,
    onInterventionClick,
    removeConversation,
    updateImagesData,
    setChatStatus,
    setBatchIndex,
    setOffsetIndex,
    setUnreadCount,
    saveSafetyTips,
    saveReplyRestrictionMetaData,
    saveSystemMessageData,
    saveKYCReplyRestrictionData,
    saveMyZoneFeatureFlag,
    saveIntentCtas,
    setChatQuickFilters
};
